export default __webpack_public_path__ + "static/media/itinerary-loading.62936f7e.gif";